import React, { ReactNode } from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

export interface StatusProps {
    children: ReactNode;
    status: string;
    isLoading: boolean;
}

// todo: should be in pbolt
const CardStatus = ({ children, status, isLoading }: StatusProps) => {
    const { theme } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
            }}>
            <Box
                sx={{
                    mr: 1,
                    display: 'flex',
                    alignItems: 'center',
                }}>
                {isLoading ? (
                    <Skeleton variant="circular" height={6} width={6} />
                ) : (
                    <svg height="6" width="6">
                        <circle
                            cx="3"
                            cy="3"
                            r="3"
                            fill={
                                status === 'NORMAL'
                                    ? theme.palette.success.main
                                    : !isLoading
                                    ? theme.palette.error.main
                                    : 'black'
                            }
                        />
                    </svg>
                )}
            </Box>
            {isLoading ? <Skeleton width={60} /> : children}
        </Box>
    );
};

export default CardStatus;
